var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.havePermisssion)?_c('router-view',{staticStyle:{"padding":"8px"}}):_c('a-result',{staticStyle:{"margin-top":"36px"},attrs:{"status":"403","title":"403","sub-title":_vm.$t('抱歉, 您无权访问此页面')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }